export default __webpack_public_path__ + "static/media/template_10.223095a6.png";